import React from 'react';

const UnAssignDriverIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.77656 1.72461L1.72656 2.77461L6.85881 7.90536C6.84906 7.94511 6.83481 7.98336 6.82656 8.02386L8.25156 9.37461V9.29811L11.7031 12.7496H11.6266L13.3516 14.4746C13.3823 14.4746 13.4131 14.4851 13.4431 14.4896L13.7273 14.7746L14.8523 15.8996L17.9273 18.9739V18.9754L19.2758 20.3246H19.2773L21.2273 22.2746L22.2758 21.2246L19.1693 18.1181C18.5168 16.0046 16.9553 14.2706 14.9266 13.4246C16.3516 12.4496 17.2516 10.8746 17.2516 9.07461C17.2516 6.14961 14.9266 3.82461 12.0016 3.82461C10.0643 3.82461 8.39256 4.86561 7.46781 6.41736L2.77656 1.72461ZM12.0016 5.24961C14.1016 5.24961 15.7516 6.89961 15.7516 8.99961C15.7516 10.5649 14.8336 11.8781 13.4971 12.4466L8.55456 7.50411C9.12306 6.16761 10.4363 5.24961 12.0016 5.24961ZM6.90156 9.97461C7.20156 11.3996 7.95156 12.5996 9.15156 13.3496C7.77723 13.9056 6.60033 14.8594 5.77182 16.0888C4.94331 17.3182 4.50098 18.7671 4.50156 20.2496H6.00156C6.00156 18.0746 7.12656 16.1996 8.85156 15.1496C9.37656 16.3496 10.5766 17.2496 12.0016 17.2496C12.6016 17.2496 13.2016 17.0996 13.6516 16.7996L12.5266 15.6746C12.3766 15.7496 12.1516 15.7496 12.0016 15.7496C11.1766 15.7496 10.5016 15.2246 10.2766 14.4746L11.1766 14.2496L6.90156 9.97461Z'
        fill='#41415A'
      />
    </svg>
  );
};

export default UnAssignDriverIcon;
